import React, { Fragment } from "react";
import PropTypes from "prop-types";
import get from "lodash/get";
import { PARTNER_CONTENT_STORY_TEMPLATE } from "../../../constants";
import { useDeviceType } from "../../custom-hooks/useDeviceType";
import { StoryCard } from "./StoryCard";

import "./four-col-four-var-one.m.css";

export const OtherStories = ({ showColumnSeparator, otherStories, showTimeStamp, showReadTime, sectionSlug }) => {
  const deviceType = useDeviceType();
  const isMobile = deviceType === "mobile";

  return (
    <div styleName={`${showColumnSeparator ? "other-stories-with-separator" : "other-stories-list"}`}>
      {otherStories.map((story, index) => {
        const sponsor = get(story, ["metadata", "sponsored-by"], null);
        const imageUrl =
          get(story, ["alternative", "home", "default", "hero-image", "hero-image-s3-key"]) ||
          get(story, ["hero-image-s3-key"]);
        const showImageThumbnail = (story["story-template"] === PARTNER_CONTENT_STORY_TEMPLATE || sponsor) && imageUrl;
        return (
          <Fragment key={index}>
            <StoryCard
              key={index}
              story={story}
              showTimeStamp={showTimeStamp}
              showReadTime={showReadTime}
              showImageThumbnail={showImageThumbnail}
              isMobile={isMobile}
              isHorizontal={showImageThumbnail && isMobile}
              sectionSlug={sectionSlug}
            />
            {showColumnSeparator && index !== otherStories.length - 1 && <div styleName="divider"></div>}
          </Fragment>
        );
      })}
    </div>
  );
};

OtherStories.propTypes = {
  otherStories: PropTypes.array.isRequired,
  showColumnSeparator: PropTypes.bool,
  showTimeStamp: PropTypes.bool,
  showReadTime: PropTypes.bool,
  isMobile: PropTypes.bool,
  sectionSlug: PropTypes.string,
};
